import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { Heading } from '@sas/nova-commons/components/Heading';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { MenuButton } from '@sas/nova-commons/components/MenuButton';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { DisclosurePrevious, Overflow, Refresh } from '@sas/react-svg';
import { forwardRef } from 'react';
import { ObjectSearchState } from '../../../../store/objectSearch/ObjectSearchState';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useI18n } from '../../../../locale/I18nContext';
import cn from './PanelHeader.css.json';
import './PanelHeader.css';
export const PanelHeaderBase = forwardRef((props, ref) => {
    const dt = useDesignTokens();
    const headerTokens = renderInlineCssVars(getHeaderTokens(dt), 'heading');
    const backTooltip = useI18n({ key: 'PanelHeader.back.tooltip.txt' });
    return (_jsxs(Flow, Object.assign({ ref: ref, spacing: 'xs', orientation: 'horizontal', className: cn.container }, { children: [_jsx(Button, { tooltip: backTooltip, icon: { icon: DisclosurePrevious }, variant: ButtonVariant.Icon, onPress: () => {
                    props.actions.update(props.id, Object.assign({ navSelection: [] }, (props.type !== 'result' && { searchHints: [] })));
                } }), _jsx(Heading, Object.assign({ id: props.headingId, level: 3, className: cn.header, style: headerTokens }, { children: props.text })), props.type === 'myLocationPin' && (_jsx(Button, { icon: { icon: Refresh }, variant: ButtonVariant.Icon, onPress: () => props.actions.notifyRefreshLocation(props.id) })), _jsx(MenuButton, { icon: { icon: Overflow }, onItemSelected: props.onMenuItemSelected, sections: props.menuSections, variant: ButtonVariant.Light })] })));
});
function getHeaderTokens(dt) {
    switch (dt.themeVariant) {
        case 'dark':
            return { fg: dt.reportTokens.c.p2 };
        case 'high-contrast':
            return { fg: dt.reportTokens.c.p3 };
        default:
            return { fg: dt.reportTokens.c.p };
    }
}
export const PanelHeader = connect(undefined, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}), undefined, { forwardRef: true })(PanelHeaderBase);
